import { FC, PropsWithChildren } from 'react';

export const Filters: FC<PropsWithChildren> = ({ children }) => (
  <ul className={'grid grid-cols-1 gap-3 sm:grid-cols-4 sm:gap-x-8 sm:gap-y-6'}>{children}</ul>
);
